/*
 *
 * Clinician constants
 *
 */

export const DEFAULT_ACTION = 'src/Clinician/DEFAULT_ACTION';
